export const Icons = {
	AR: {
		promotion_tag: 'https://storage.googleapis.com/tirx-resources-develop/1e20fb76-f295-4f3f-871c-eec88859b6ed.png',
		NP: 'https://storage.googleapis.com/tirx-resources-production/505ec589-45b4-45b1-a42d-98a7625a4c30.png',
		RMRSCS: 'https://storage.googleapis.com/tirx-resources-production/83c264f0-d3ea-4900-a8ef-4ad1386a81a9.png',
		WP: 'https://storage.googleapis.com/master-image-bucket/condicion-venta/Receta%20me%CC%81dica.png',
	},
	CL: {
		promotion_tag: 'https://storage.googleapis.com/tirx-resources-develop/1e20fb76-f295-4f3f-871c-eec88859b6ed.png',
		NP: 'https://storage.googleapis.com/tirx-resources-production/d09b5baf-2dd7-4d06-8389-8f20bd056fd6.png',
		RMRSCS: 'https://storage.googleapis.com/tirx-resources-production/505ec589-45b4-45b1-a42d-98a7625a4c30.png',
		MRE: 'https://storage.googleapis.com/tirx-resources-production/83c264f0-d3ea-4900-a8ef-4ad1386a81a9.png',
		APR: 'https://storage.googleapis.com/tirx-resources-production/83c264f0-d3ea-4900-a8ef-4ad1386a81a9.png',
		WP: 'https://storage.googleapis.com/tirx-resources-production/83c264f0-d3ea-4900-a8ef-4ad1386a81a9.png',
		
	},
		CLNARMA: {
		promotion_tag: 'https://storage.googleapis.com/tirx-resources-develop/1e20fb76-f295-4f3f-871c-eec88859b6ed.png',
		NP: 'https://storage.googleapis.com/tirx-resources-production/d09b5baf-2dd7-4d06-8389-8f20bd056fd6.png',
		RMRSCS: 'https://storage.googleapis.com/tirx-resources-production/505ec589-45b4-45b1-a42d-98a7625a4c30.png',
		MRE: 'https://storage.googleapis.com/tirx-resources-production/83c264f0-d3ea-4900-a8ef-4ad1386a81a9.png',
		APR: 'https://storage.googleapis.com/tirx-resources-production/83c264f0-d3ea-4900-a8ef-4ad1386a81a9.png',
		WP: 'https://storage.googleapis.com/tirx-resources-production/83c264f0-d3ea-4900-a8ef-4ad1386a81a9.png',
		
	},

		CLGREEN: {
		promotion_tag: 'https://storage.googleapis.com/tirx-resources-develop/1e20fb76-f295-4f3f-871c-eec88859b6ed.png',
		NP: 'https://storage.googleapis.com/tirx-resources-production/d09b5baf-2dd7-4d06-8389-8f20bd056fd6.png',
		RMRSCS: 'https://storage.googleapis.com/tirx-resources-production/505ec589-45b4-45b1-a42d-98a7625a4c30.png',
		MRE: 'https://storage.googleapis.com/tirx-resources-production/83c264f0-d3ea-4900-a8ef-4ad1386a81a9.png',
		APR: 'https://storage.googleapis.com/tirx-resources-production/83c264f0-d3ea-4900-a8ef-4ad1386a81a9.png',
		WP: 'https://storage.googleapis.com/tirx-resources-production/83c264f0-d3ea-4900-a8ef-4ad1386a81a9.png',
		
	},
	CLANICX: {
		promotion_tag: 'https://storage.googleapis.com/tirx-resources-develop/1e20fb76-f295-4f3f-871c-eec88859b6ed.png',
		NP: 'https://storage.googleapis.com/tirx-resources-production/d09b5baf-2dd7-4d06-8389-8f20bd056fd6.png',
		RMRSCS: 'https://storage.googleapis.com/tirx-resources-production/505ec589-45b4-45b1-a42d-98a7625a4c30.png',
		MRE: 'https://storage.googleapis.com/tirx-resources-production/83c264f0-d3ea-4900-a8ef-4ad1386a81a9.png',
		APR: 'https://storage.googleapis.com/tirx-resources-production/83c264f0-d3ea-4900-a8ef-4ad1386a81a9.png',
		WP: 'https://storage.googleapis.com/tirx-resources-production/83c264f0-d3ea-4900-a8ef-4ad1386a81a9.png',
	},
	MX: {
		promotion_tag: 'https://storage.googleapis.com/tirx-resources-develop/1e20fb76-f295-4f3f-871c-eec88859b6ed.png',
		NP: 'https://storage.googleapis.com/tirx-resources-production/505ec589-45b4-45b1-a42d-98a7625a4c30.png',
		RMRSCS: 'https://storage.googleapis.com/tirx-resources-production/83c264f0-d3ea-4900-a8ef-4ad1386a81a9.png',
		WP: 'https://storage.googleapis.com/master-image-bucket/condicion-venta/Receta%20me%CC%81dica.png',
	},
};
Icons.CLZUPHARMA = Icons.CLGREEN;
